// extracted by mini-css-extract-plugin
export default {"wrapper":"Statistic_wrapper__mpQtG","stat-user":"Statistic_stat-user__tujQk","stat-cate-post":"Statistic_stat-cate-post__jrtM1","stat-room":"Statistic_stat-room__Zxlc8"};